/*
Prakash 11/23/2022  2700912712  Removed card component.
Rajesh 12/02/022 2700912712 side nav changes
Rohini 12/05/2022 2700912712   changed side nav format
Ashraf 12/05/2022 2700912712 Fixed header labels
Ashraf 01/11/2022 2700912712 conditional renders for audit list
Akhila 07/01/2023 2700912712 field list name change to audit field list
*/
import React, {useContext, useEffect} from 'react';
import SubTabsContent from './SubTabsContent';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router';
import {setReduxState} from '../../../../redux/reducers/BRE/AddRuleGroup';
import LandingPage from '../../../LandingPage';
const GLobalFieldList = ({tabValue, setTabValue, StepperFieldList}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  useEffect(() => {
    dispatch(setReduxState({property: 'formData', value: {}}));
    dispatch(setReduxState({property: 'category', value: ''}));
  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels =
    location.pathname === '/frameworks/audit-field-list' ?
      ['Audit Field List'] :
      ['Audit Field List'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={value}
        handleTabChange={handleChange}
        allAntTabs={tabLabels}
      >
        <div className={`global-field-dash-board`}>
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                <SubTabsContent AuditFieldList={location.pathname === '/frameworks/audit-field-list'} setTabValue={setTabValue} StepperFieldList={StepperFieldList} />
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};

export default GLobalFieldList;
